import { defineMessages } from 'react-intl';

export default defineMessages({
  'Reverse.Repairer.Errors.RepairerQuote.AlreadyInProgressQuoteForTheFile': {
    id: 'Reverse.Repairer.Errors.RepairerQuote.AlreadyInProgressQuoteForTheFile',
    defaultMessage: 'There is already a quote in progress for this file',
  },
  'Reverse.Repairer.Errors.RepairerQuote.UnallowedService': {
    id: 'Reverse.Repairer.Errors.RepairerQuote.UnallowedService',
    defaultMessage: 'The service is not allowed for this file.',
  },

  'Reverse.Repairer.Errors.RepairerQuote.StateMustBeDraft': {
    id: 'Reverse.Repairer.Errors.RepairerQuote.StateMustBeDraft',
    defaultMessage: 'The state must in draft',
  },

  'Reverse.Repairer.Errors.RepairerQuote.StateMustBeCompleted': {
    id: 'Reverse.Repairer.Errors.RepairerQuote.StateMustBeCompleted',
    defaultMessage: 'The state must be completed',
  },

  'Reverse.Repairer.Errors.RepairerQuote.BadAmount': {
    id: 'Reverse.Repairer.Errors.RepairerQuote.BadAmount',
    defaultMessage:
      'You must the set LaborPrice and PartsPrice Or the BundlePrice',
  },

  'Reverse.Repairer.Errors.RepairerQuote.BadActorType': {
    id: 'Reverse.Repairer.Errors.RepairerQuote.BadActorType',
    defaultMessage: 'The actor must be a repairer',
  },

  'Reverse.Repairer.Errors.RepairerQuote.QuoteMustBeApprovedBeforePayment': {
    id: 'Reverse.Repairer.Errors.RepairerQuote.QuoteMustBeApprovedBeforePayment',
    defaultMessage: 'A quote must be approved before payment.',
  },

  'Reverse.Repairer.Errors.RepairerQuote.QuoteMustHaveAnAmmountGreaterThanZeroToBePaid':
    {
      id: 'Reverse.Repairer.Errors.RepairerQuote.QuoteMustHaveAnAmmountGreaterThanZeroToBePaid',
      defaultMessage:
        'A quote must have an ammount greater than zero to be paid.',
    },

  'Reverse.Repairer.Errors.RepairerQuote.QuoteMustBeInPendingCustomerValidationToBeRejected':
    {
      id: 'Reverse.Repairer.Errors.RepairerQuote.QuoteMustBeInPendingCustomerValidationToBeRejected',
      defaultMessage:
        'The quote must be in pending customer validation to be rejected',
    },

  'Reverse.Repairer.Errors.RepairerQuote.QuoteMustBeInPendingCustomerValidationToBeApproved':
    {
      id: 'Reverse.Repairer.Errors.RepairerQuote.QuoteMustBeInPendingCustomerValidationToBeApproved',
      defaultMessage:
        'The quote must be in pending customer validation to be approved',
    },
  'Reverse.Repairer.Errors.RepairerQuote.InvalidTypeForQuotationSubContractorInformationUpdate':
    {
      id: 'Reverse.Repairer.Errors.RepairerQuote.InvalidTypeForQuotationSubContractorInformationUpdate',
      defaultMessage:
        "You can't change subcontractor informations if it's not a subcontrator quote",
    },
  'Reverse.Repairer.Errors.RepairerQuote.QuotationAmountCannotBeLessOrEqualTo0':
    {
      id: 'Reverse.Repairer.Errors.RepairerQuote.QuotationAmountCannotBeLessOrEqualTo0',
      defaultMessage: "Quotation can't be equal or bellow zero",
    },
});
